// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__29fwE","list":"BalanceDue_list__29jS1","listRow":"BalanceDue_listRow__1GJZn","total":"BalanceDue_total__fA6SA"};